/**
 * Side margin for what sits straight on a Polaris `Page` and is not a Polaris Card: text, a search
 * field, a picker, a row of buttons, a box we draw ourselves.
 *
 * Below 490 px Polaris gives a page no side padding. A Polaris Card then runs edge to edge (that is
 * Polaris's own phone layout, and the card's content keeps its padding); anything else touches the
 * screen edge. From 490 px Polaris adds its own padding, which this must not double. The class
 * names are written out in full because Tailwind reads them as text.
 */
export const PHONE_PAGE_GUTTER = "px-4 min-[490px]:px-0";

/** The same gutter as a margin, for a box with its own border or background (padding would sit inside it). */
export const PHONE_PAGE_MARGIN = "mx-4 min-[490px]:mx-0";
